import useAsync from 'Hooks/useAsync';
import { getCategoriesApi } from 'API/tableAPI/groupAPI';

const useCategories = (categoryName?: string) => {
  return useAsync(() => getCategoriesApi(categoryName), {
    deps: [categoryName],
  });
};

export default useCategories;
